import { render, staticRenderFns } from "./DynamicNews.vue?vue&type=template&id=af163f90&scoped=true"
import script from "./DynamicNews.vue?vue&type=script&lang=js"
export * from "./DynamicNews.vue?vue&type=script&lang=js"
import style0 from "./DynamicNews.vue?vue&type=style&index=0&id=af163f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af163f90",
  null
  
)

export default component.exports